import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '@service/api.service';
import { LoggerService } from '@service/logger.service';
import { catchError, map, mergeMap, of } from 'rxjs';

import * as AccountActions from '../actions/account.actions';
import * as DocumentSubTypesActions from '../actions/document-subtypes.actions';

@Injectable()
export class DocumentSubTypesEffects {
  private actions$ = inject(Actions);
  private apiService = inject(ApiService);
  private loggerService = inject(LoggerService);

  /**
   * Triggers loading of document sub types once account details have been
   * successfully loaded, ensuring authentication is in place before the API call.
   */
  loadDocumentSubTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AccountActions.loadAccountDetailsSuccess, DocumentSubTypesActions.loadDocumentSubTypes),
      mergeMap(() => {
        this.loggerService.debug('[DocumentSubTypesEffects] Effect triggered: Load Document Sub Types');
        return this.apiService.findDocumentSubTypes().pipe(
          map((subtypes) => DocumentSubTypesActions.loadDocumentSubTypesSuccess({ subtypes })),
          catchError((error) => {
            this.loggerService.error('API call failed: ', error);
            return of(DocumentSubTypesActions.loadDocumentSubTypesFailure({ error }));
          })
        );
      })
    )
  );
}
